module.exports = __webpack_public_path__ + "static/media/list.active.b41d0e68.svg";